import React from 'react'
import { Consumer } from './formProvider'

export default class Select extends React.Component {
    render() {
        const {
            name = '',
            classNames = '',
            placeholder = '',
            required = false,
            options,
            preSelectedOption
        } = this.props

        return (
            <Consumer>
                {({ handleChange }) => (
                    <React.Fragment>
                        <div className="hs-select__wrap">
                            <select
                                className={`input-base hs-select ${classNames}`}
                                name={name}
                                required={required}
                                defaultValue={preSelectedOption || ''}
                                onChange={handleChange(name)}
                                placeholder={placeholder}
                            >
                                <React.Fragment>
                                    <option disabled value={''}>
                                        {placeholder}
                                    </option>
                                    {options.map(opt => (
                                        <option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </option>
                                    ))}
                                </React.Fragment>
                            </select>
                        </div>
                    </React.Fragment>
                )}
            </Consumer>
        )
    }
}